module.exports = __webpack_public_path__ + "img/zhxxxgwk.9616890b.png";